<template>
  <div
    class="result">
    <h2
      class="title">
      <translate>Resultat</translate>
    </h2>
    <b-table
      :data="truncatedResults"
      default-sort-direction="desc"
      default-sort="points">
      <template slot-scope="props">
        <b-table-column
          field="position"
          :label="$gettext('Placering')"
          sortable
          numeric>
          {{ props.row.position }}
        </b-table-column>
        <b-table-column
          field="number"
          :label="$gettext('Nr')"
          sortable
          numeric>
          {{ props.row.number }}
        </b-table-column>
        <b-table-column
          field="name"
          :label="$gettext('Namn')"
          sortable>
          {{ props.row.name }}
        </b-table-column>
        <b-table-column
          field="country"
          :label="$gettext('Land')"
          sortable>
          {{ props.row.country }}
        </b-table-column>
        <b-table-column
          field="quantity"
          :label="$gettext('Antal')"
          sortable
          numeric>
          {{ props.row.quantity }}
        </b-table-column>
        <b-table-column
          field="weight"
          :label="$gettext('Vikt')"
          sortable
          numeric
          :custom-sort="sortFloat">
          {{ props.row.weight.toLocaleString('fi-SV') }} kg
        </b-table-column>
        <b-table-column
          field="length"
          :label="$gettext('Längd')"
          sortable
          numeric
          :custom-sort="sortFloat">
          {{ props.row.length.toLocaleString('fi-SV') }} cm
        </b-table-column>
        <b-table-column
          field="points"
          :label="$gettext('Poäng')"
          sortable
          numeric>
          {{ Math.round(props.row.points) }}
        </b-table-column>
      </template>
    </b-table>
  </div>
</template>


<script>
import { sortFloat } from '../_helpers';

export default {
  name: 'Result',
  props: {
    results: {
      type: Array,
      default: () => {return []},
    },
    trunc: {
      type: Number,
      default: undefined,
    },
  },
  data () {
    return {
      sortFloat,
    }
  },
  computed: {
    truncatedResults: function() {
      if (!this.trunc){
        return this.results
      }
      let copy = this.results.slice();
      return copy.slice(0,this.trunc)
    }
  },
  created() {
  },
  methods: {
  },
}
</script>
<style scoped>
.main-content {
  padding: 30px;
}
.competition {
  font-size: 12px;
}
.title {
  font-size: 1.5em;
}
.section {
  padding: 12px;
}
.panel {
  font-size: 1em;
}
.button {
  font-size: 12px;
}
</style>
